module.exports = __webpack_public_path__ + "img/ladybug.0288a30d.jpg";